<ion-content>
  <h1 style="margin-left: 20px; font-size: 1.7rem">Deflection Analytics Overview</h1>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <div style="padding: 10px; height: 400px">
          <canvas #myChart></canvas>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-card class="outline-card">
          <div style="margin: 20px 20px 10px 20px">
            <h1 style="font-size: 1.2rem; margin-top: 0">AI-Generated Response History</h1>
            <div class="flex-space-between">
              <div class="flexed flexed-align-center">
                <span style="margin-right: 10px; flex-shrink: 0; padding: 5px" class="pill-tab-container">
                  <div
                    class="round-pill-tab round-pill-tab-left"
                    [ngClass]="{
                      'round-pill-tab-active': filterType === 'all'
                    }"
                    (click)="filterType = 'all'; loadResponses()"
                  >
                    All
                  </div>
                  <div
                    class="round-pill-tab round-pill-tab-right"
                    [ngClass]="{
                      'round-pill-tab-active': filterType === 'no_response'
                    }"
                    (click)="filterType = 'no_response'; loadResponses()"
                  >
                    No response
                  </div>
                  <div
                    class="round-pill-tab round-pill-tab-right"
                    [ngClass]="{
                      'round-pill-tab-active': filterType === 'has_response'
                    }"
                    (click)="filterType = 'has_response'; loadResponses()"
                  >
                    Has response
                  </div>
                </span>
                <div>
                  <ion-button
                    color="dark"
                    fill="clear"
                    class="button-dark-border"
                    (click)="showDateRangeOptions()"
                    [disabled]="isLoading"
                    [ngClass]="{ 'button-round-left': dateRange.type === 'absolute' }"
                  >
                    <ion-icon name="calendar" class="filter-button-icon"></ion-icon>
                    {{ dateRange.label }}
                    <ion-icon name="chevron-down-outline" class="filter-button-caret"></ion-icon>
                  </ion-button>
                  <ion-button
                    color="dark"
                    fill="clear"
                    (click)="changeDate(false)"
                    *ngIf="dateRange.type === 'absolute'"
                    style="margin-left: 0; margin-right: 0; --padding-end: 6px"
                    [disabled]="isLoading"
                  >
                    {{ startDate | date: 'M/d/yyyy' }}
                  </ion-button>
                  <ion-button
                    color="dark"
                    fill="clear"
                    *ngIf="dateRange.type === 'absolute'"
                    disabled="true"
                    style="--padding-start: 0; margin: 0; --padding-end: 0"
                    [disabled]="isLoading"
                  >
                    –
                  </ion-button>
                  <ion-button
                    color="dark"
                    fill="clear"
                    (click)="changeDate(true)"
                    *ngIf="dateRange.type === 'absolute'"
                    style="--padding-start: 6px"
                    [disabled]="isLoading"
                  >
                    {{ endDate | date: 'M/d/yyyy' }}
                  </ion-button>
                  <ion-button
                    color="warning"
                    *ngIf="isDateRangeInvalid"
                    shape="round"
                    ngxTippy
                    [tippyProps]="{
                      arrow: false,
                      placement: 'bottom'
                    }"
                    data-tippy-content="Invalid date range"
                    [disabled]="isLoading"
                  >
                    <ion-icon name="warning-outline"></ion-icon>
                  </ion-button>
                </div>
                <app-filter-button
                  [options]="filterOptions"
                  (didChange)="filtersDidChange($event)"
                  style="margin-left: 5px"
                ></app-filter-button>
              </div>
              <div class="flexed-align-center">
                <ion-button
                  color="dark"
                  fill="clear"
                  class="button-dark-border"
                  (click)="exportAsCsv()"
                  ngxTippy
                  [tippyProps]="{
                    arrow: false,
                    placement: 'bottom'
                  }"
                  data-tippy-content="Download as CSV"
                >
                  <ion-icon name="cloud-download-outline" style="font-size: 1.05rem"></ion-icon>
                </ion-button>
              </div>
            </div>
          </div>
          <ngx-datatable
            class="material datatable-row-borders datatable-row-top-aligned"
            [loadingIndicator]="isLoading"
            columnMode="force"
            paginated
            [dataSource]="responsesDateSource"
            [limit]="50"
            [headerHeight]="50"
            [footerHeight]="50"
            rowHeight="auto"
            [scrollbarH]="true"
            [rows]="feedbackItems"
            [reorderable]="true"
          >
            <ngx-datatable-column name="Query" prop="query" [minWidth]="440" [width]="440" [sortable]="false">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div style="display: flex; flex-direction: column">
                  <div style="font-weight: 500">
                    <div [innerHTML]="row.formattedQuery"></div>
                    <a
                      *ngIf="row.conversation && row.conversation.status !== draftStatus"
                      routerDirection="root"
                      [routerLink]="['/dashboard/inbox/all/conversations', row.conversation?.id]"
                      >&nbsp;[#{{ row.conversation?.friendly_id }}]</a
                    >
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="AI Response" prop="response" [minWidth]="440" [width]="440" [sortable]="false">
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div [innerHTML]="row.formattedResponse"></div>
                <div *ngIf="!row.response" class="feedback-chip no-response">
                  <ion-icon name="ban-outline"></ion-icon>
                  <span style="margin-left: 3px">No response</span>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="User Feedback"
              prop="userFeedbackType"
              [minWidth]="200"
              [maxWidth]="200"
              [width]="200"
              [sortable]="false"
            >
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div
                  *ngFor="let feedback of row.feedbacks"
                  class="feedback-chip thumbs-up"
                  [ngClass]="{
                    'thumbs-up': feedback.type === 'thumbs_up',
                    'thumbs-down': feedback.type === 'thumbs_down'
                  }"
                >
                  <ion-icon [name]="feedback.type === 'thumbs_up' ? 'thumbs-up' : 'thumbs-down'"></ion-icon>
                  <span style="margin-left: 3px" *ngIf="feedback.message">{{ feedback.message }}</span>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Customer"
              prop="conversation.customer.name"
              [minWidth]="200"
              [maxWidth]="200"
              [width]="200"
              [sortable]="false"
            >
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                {{ value }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Ticket Type"
              prop="conversation.ticketType.name"
              [minWidth]="200"
              [maxWidth]="200"
              [width]="200"
              [sortable]="false"
            >
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                {{ value }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Created"
              prop="createdAt"
              [minWidth]="200"
              [maxWidth]="200"
              [width]="200"
              [sortable]="false"
            >
              <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                {{ value | date: 'M/d/yyyy h:mm a' }}
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
